import token, { tokenToVars } from '../token';
import TreeSelect from './tree-select';

export { TreeSelect };
export default tokenToVars(TreeSelect, token);
